import React from 'react'
import { Row, Col, Form, Input } from 'antd'
import MemoryStore from '../../../../../utils/memory-store'

class ConnectorsFormTypeDB2ISeries extends React.Component {
  constructor (props) {
    super(props)

    this.entry = MemoryStore.activeEntries[this.props.tabKey]

    this.state = { entry: props.entry }
    this.onFieldChange = this.onFieldChange.bind(this)
  }

  onFieldChange (key, value) {
    this.entry.custom.isModified = true
    this.props.entry[key] = value
  }

  render () {
    return (
      <Row>
        <Col xs={24} lg={16}>
          <Form.Item>
            <span style={{ color: 'red' }}>* </span>
            Host
            <Input
              placeholder='Provide a Host'
              disabled={MemoryStore.userProfile.teamPrivileges.connectors === 'Reader'}
              defaultValue={this.state.entry.host}
              onChange={e => {
                this.onFieldChange('host', e.target.value)
              }}
            />
          </Form.Item>
          <Form.Item>
            Port
            <Input
              placeholder='Port'
              disabled={MemoryStore.userProfile.teamPrivileges.connectors === 'Reader'}
              defaultValue={this.state.entry.port}
              onChange={e => {
                this.onFieldChange('port', e.target.value)
              }}
            />
          </Form.Item>
          <Form.Item>
            Username
            <Input
              placeholder='Provide a Username'
              disabled={MemoryStore.userProfile.teamPrivileges.connectors === 'Reader'}
              defaultValue={this.state.entry.username}
              onChange={e => {
                this.onFieldChange('username', e.target.value)
              }}
            />
          </Form.Item>
          <Form.Item>
            Password
            <Input
              placeholder='Provide a Password'
              disabled={MemoryStore.userProfile.teamPrivileges.connectors === 'Reader'}
              defaultValue={this.state.entry.password}
              autoComplete='new-password'
              type='password'
              onChange={e => {
                this.onFieldChange('password', e.target.value)
              }}
            />
          </Form.Item>
        </Col>
      </Row>
    )
  }
}

export default ConnectorsFormTypeDB2ISeries
